export const TapOptimizeRoute = {
  TAP_OPTIMIZE: 'tapoptimize',
};

export const TapOptimizePathName = {
  TAP_OPTIMIZE: 'tapoptimize',
  TAP_OPTIMIZE_FORM_NEW: 'tapoptimizeform:new',
  TAP_OPTIMIZE_FORM: 'tapoptimizeform',
  TAP_OPTIMIZE_DASHBOARD: 'tapoptimize:dash',
};
